export default {
  path: 'users',
  name: 'users',
  redirect: { name: 'tradies' },
  component: () => import(/* webpackChunkName: "auth" */ '@/views/Home/Users'),
  children: [
    {
      path: 'tradies',
      name: 'tradies',
      component: () =>
        import(/* webpackChunkName: "tradies" */ '@/views/Home/Users/Tradies')
    },
    {
      path: 'tradies/:id',
      name: 'tradies.details',
      component: () =>
        import(
          /* webpackChunkName: "tradies" */ '@/views/Home/Users/Tradies/Details'
        )
    },
    {
      path: 'business-admin',
      name: 'business-admin',
      component: () =>
        import(
          /* webpackChunkName: "business-admin" */ '@/views/Home/Users/BusinessAdmin'
        )
    },
    {
      path: 'business-admin/:id',
      name: 'business-admin.details',
      component: () =>
        import(
          /* webpackChunkName: "business-admin" */ '@/views/Home/Users/BusinessAdmin/Details'
        )
    }
  ]
}
